'use client';

import type React from 'react';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { MessageSquarePlus } from 'lucide-react';

interface EmptyChatsStateProps {
  onNewChat: () => void;
}

const EmptyChatsState: React.FC<EmptyChatsStateProps> = ({ onNewChat }) => {
  return (
    <Card className="w-full max-w-md mx-auto">
      <CardHeader>
        <CardTitle>No AI Chats</CardTitle>
        <CardDescription>You haven't created any AI chats yet.</CardDescription>
      </CardHeader>
      <CardContent className="text-center py-8">
        <div className="flex justify-center mb-4">
          <MessageSquarePlus className="h-16 w-16 text-muted-foreground" />
        </div>
        <p className="text-muted-foreground">Start a new AI chat to begin a conversation.</p>
      </CardContent>
      <CardFooter>
        <Button onClick={onNewChat} className="w-full">
          Create New Chat
        </Button>
      </CardFooter>
    </Card>
  );
};

export default EmptyChatsState;
